import { render, staticRenderFns } from "./WorkReport.vue?vue&type=template&id=5a606d68&scoped=true"
import script from "./WorkReport.vue?vue&type=script&lang=ts"
export * from "./WorkReport.vue?vue&type=script&lang=ts"
import style0 from "./WorkReport.vue?vue&type=style&index=0&id=5a606d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a606d68",
  null
  
)

export default component.exports